import { Map } from 'immutable'
import { browserHistory } from 'react-router'

import authenticationService from '../services/authentication'

const LOGIN = 'authentication/LOGIN'
export const LOGOUT = 'authentication/LOGOUT'
const LOGIN_FAILED = 'authentication/LOGIN_FAILED'

const defaultState = Map({
  hasLoginFailed: null
})

export default function(state = defaultState, action = undefined) {
  switch (action.type) {
    case LOGIN:
      return state.update('hasLoginFailed', hasFailed => null)

    case LOGIN_FAILED:
      return state.update('hasLoginFailed', hasFailed => action.payload)

    case LOGOUT:
      return (state = defaultState)

    default:
      return state
  }
}

export function login(username, password) {
  return function d(dispatch) {
    dispatch({ type: LOGIN_FAILED, payload: null })

    return authenticationService.login(username.toLowerCase(), password).then(response => {
      if (response.data.error) {
        return dispatch({ type: LOGIN_FAILED, payload: true })
      }

      dispatch({ type: LOGIN })

      browserHistory.push('/')
    })
  }
}

export function logout() {
  return dispatch => {
    return authenticationService.logout().then(response => {
      browserHistory.push('/login')

      dispatch({ type: LOGOUT })
    })
  }
}



// WEBPACK FOOTER //
// ./src/ducks/authentication.js